import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import { AlertStyled, WrapperIconStyled } from './WireAlert.styles';

const loginLockIcon = (
  <SharedAsset
    alt=""
    src="/s2/vector/login-lock-256.svg"
    width={72}
  />
);

export default function WireAlert() {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  return (
    <AlertStyled>
      <Stack
        direction="row"
        spacing="16px"
      >
        <WrapperIconStyled>{!isMobile && loginLockIcon}</WrapperIconStyled>
        <Stack spacing="4px">
          <Text
            color="primary"
            size="lg"
            weight="medium"
          >
            For your security
          </Text>
          <Text
            color="primary"
            size="md"
          >
            To send wire transfers, we must verify your account again. This only takes a few
            seconds.
          </Text>
        </Stack>
      </Stack>
    </AlertStyled>
  );
}
